/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import logo from '../assets/logo.png'

const HeaderComponent = () => {
  return (
    <header>
      {/* Header Start */}
      <div className="header-area header_area header-transparent">
        <div className="main-header">
          <div
            className="header-bottom header-sticky"
            // style={{ background: '#212121' }}
          >
            <div className="container-fluid">
              <div className="row align-items-center">
                {/* Logo */}
                <div className="col-xl-2 col-lg-1 col-md-1">
                  <div className="logo">
                    <a href="/">
                      <img
                        src={logo}
                        alt="logo eggless"
                        style={{ width: '120px' }}
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-8 col-md-8">
                  {/* Main-menu */}
                  <div className="main-menu f-right d-none d-lg-block">
                    <nav>
                      <ul id="navigation">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/about">About</a>
                        </li>
                        <li>
                          <a href="/service">Services</a>
                        </li>
                        <li>
                          <a href="/work">Works</a>
                        </li>
                        <li>
                          <a href="#">Product</a>
                          <ul className="submenu">
                            <li>
                              <a href="/productpena">Pena</a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="/content">Content</a>
                        </li>
                        <li>
                          <a href="/contact">Contact</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-3">
                  <div className="header-right-btn f-right d-none d-lg-block">
                    <a href="/contact" className="btn header-btn">
                      Contact Now
                    </a>
                  </div>
                </div>
                {/* Mobile Menu */}
                <div className="col-12">
                  <div className="mobile_menu d-block d-lg-none" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Header End */}
    </header>
  )
}

export default HeaderComponent
